import { h } from '@stencil/core';
import { isMobile } from '../../../globals/utils';
export class ProductAwards {
  resizeWindowHandler() {
    this.isMobile = isMobile();
  }
  constructor() {
    this.title = undefined;
    this.awards = undefined;
    this.isMobile = isMobile();
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return this.isMobile ? (h("pes-collapsible-container", null, h("pes-section-header", { slot: "header", class: "description__heading" }, this.title), h("pes-awards-carousel", { awards: this.awards }))) : (h("pes-section-with-header", { headingLabel: this.title, withColumns: true }, h("pes-awards-carousel", { awards: this.awards })));
  }
  static get is() { return "pes-product-awards"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["product-awards.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["product-awards.css"]
    };
  }
  static get properties() {
    return {
      "title": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "title",
        "reflect": false
      },
      "awards": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductAward[]",
          "resolved": "TProductAward[]",
          "references": {
            "TProductAward": {
              "location": "import",
              "path": "../specifications/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get states() {
    return {
      "isMobile": {}
    };
  }
  static get elementRef() { return "el"; }
  static get listeners() {
    return [{
        "name": "resize",
        "method": "resizeWindowHandler",
        "target": "window",
        "capture": false,
        "passive": true
      }];
  }
}
